
















































import Vue from 'vue';
import { Prop, Model } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import XSVG from '@assets/svg/x.svg';

@Component({
	componentId: 'C024',
	components: {
		ButtonComponent,
		XSVG
	},
	inheritAttrs: false
})
export default class FileInput extends Vue {
	@Prop(String)
	protected readonly id!: string;

	@Prop(String)
	protected readonly name!: string;

	@Prop(String)
	protected readonly label?: string;

	@Prop({ type: Boolean, default: false })
	protected readonly multiple!: boolean;

	@Prop({ type: Number, default: 20 })
	protected readonly maxFiles!: number;

	@Prop({ type: Boolean, default: false })
	protected readonly hasError!: boolean;

	@Model('input', { type: Array, default: () => [] })
	protected readonly files!: File[];

	protected get inputId(): string {
		return `${this.id}-input`;
	}

	protected get attrsWithoutValue(): any {
		const inputAttributes: any = this.$attrs;
		if (inputAttributes.value && inputAttributes.value.length === 0) {
			inputAttributes.value = '';
		} else {
			delete inputAttributes.value;
		}

		return inputAttributes;
	}

	protected get canAddMoreFiles(): boolean {
		return (this.multiple && this.files.length < this.maxFiles) || (!this.multiple && this.files.length === 0);
	}

	protected onInput(event: Event): void {
		const newFiles: FileList | null = (event.target as HTMLInputElement).files;
		const files: File[] = [...this.files];

		if (newFiles) {
			files.push(...newFiles);
		}

		// More files added then allowed?
		if (files.length >= this.maxFiles) {
			files.length = this.maxFiles;
		}

		this.$emit('input', files);
	}

	protected removeFile(file: File): void {
		const files: File[] = this.files.filter((fileInList: File): boolean => fileInList !== file);

		this.$emit('input', files);
	}

	protected reset(): void {
		(this.$refs.input as HTMLInputElement).value = '';

		this.$emit('input', []);
	}
}
